import Vue from 'vue';
import fullscreen from 'vue-fullscreen';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';

Vue.config.productionTip = process.env.NODE_ENV !== 'production';
Vue.config.devtools = process.env.NODE_ENV !== 'production';

Vue.use(fullscreen);

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
}).$mount('#app');
